import React, { useState, useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/dataTables.buttons";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../components/common/Loader.jsx";
import NoContent from "../../components/common/NoContent.jsx";

const Enquiries = () => {
  const tableRef = useRef(null);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [enquiries, setEnquiries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [totalRecordCount, setTotalRecordCount] = useState("");
  const getEnquiries = (page = 1) => {
    return new Promise((resolve, reject) => {
      fetch(`${baseUrl}api/school/enquiries?page=${page}`)
        .then((result) => result.json())
        .then((jsonbody) => {
          console.warn(jsonbody);
          setEnquiries(jsonbody.data);
          setTotalPages(jsonbody.last_page);
          setTotalRecordCount(jsonbody.total);
          setIsLoading(false);
          resolve(jsonbody);
          initializeDataTable();
        })
        .catch((error) => {
          console.error("Error fetching student applications:", error);
          setIsLoading(false);
          reject(error);
        });
    });
  };

  useEffect(() => {
    getEnquiries().catch((error) => {
      console.error("Error fetching student Enquiries:", error);
    });
  }, []);

  const initializeDataTable = () => {
    const table = $(tableRef.current).DataTable({
      pageLength: 10,
      scrollX: true,
      scrollCollapse: true,
      dom: "Bfrtip", // Add this line to enable the Buttons extension
      buttons: [
        "excelHtml5", // Excel button
        "csvHtml5", // CSV button
        "pdfHtml5", // PDF button
        // 'print',      // Print button
      ],
      initComplete: function () {
        const pagination = $(this)
          .closest(".dataTables_wrapper")
          .find(".dataTables_paginate");
        // Remove existing pagination
        pagination.empty();
      },
    });
  };

  const handleChangePage = (event) => {
    setIsLoading(true);
    setCurrentPage(parseInt(event.target.value, 10));
    getEnquiries(parseInt(event.target.value, 10));
  };

  return (
    <>
      <div className="middle-sidebar-bottom">
        <div className="middle-sidebar-left">
          <div className="row">
            <ToastContainer />
            <div className="col-lg-12 pt-0 mb-3 d-flex justify-content-between">
              <div>
                <h2 className="fw-400 font-lg d-block">
                  All <b> Enquiries</b>
                </h2>
              </div>
            </div>
            {isLoading ? (
              <Loader />
            ) : enquiries && enquiries.length > 0 ? (
              <div className="card-body p-lg-5 p-4 w-100 border-0 ">
                <table ref={tableRef} id="myTable" className="table">
                  <thead>
                    <tr>
                      <th scope="col">Sl. No.</th>
                      <th scope="col">First Name</th>
                      <th scope="col">Last Name</th>
                      <th scope="col">Contact</th>
                      <th scope="col">Query</th>
                      <th scope="col">Message</th>
                      <th scope="col">Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {enquiries.map((enquiry, index) => (
                      <tr key={index}>
                        <td className="">{index + 1}</td>
                        <td className="">{enquiry.firstname}</td>
                        <td className="">{enquiry.lastname}</td>
                        <td className="">{enquiry.contact}</td>
                        <td className="">{enquiry.query}</td>
                        <td className="">{enquiry.message}</td>
                        <td className="">{enquiry.created_at}</td>
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="row d-flex justify-content-end">
                  <div className="col-2">
                    <h4 className="font-xss fw-500 mt-2">
                      Total Records: {totalRecordCount}
                    </h4>
                  </div>
                  <div className="col-2 text-right">
                    <select
                      className="p-2 d-inline-block text-dark fw-500 lh-30 rounded-lg text-center font-xsss ls-3 border-3"
                      value={currentPage}
                      onChange={handleChangePage}
                    >
                      {Array.from({ length: totalPages }, (_, index) => (
                        <option key={index + 1} value={index + 1}>
                          Page {index + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            ) : (
              <NoContent contentName="Enquiries" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Enquiries;
